import React from "react";
import { useTheme } from "../../contexts/ThemeContext";

const ExitIcon = ({ onClick }) => {
  const { theme } = useTheme();
  const color = theme === "dark" ? "white" : "#0A61F5";
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <path
        d="M1 13.5L7 7.5L13 13.5M13 1.5L6.99886 7.5L1 1.5"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ExitIcon;
